import React, { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";

import API, { ENDPOINTS } from "../../api/apiService";

const ImageCarousel = () => {
  const [images, setImages] = useState([]);
  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = async () => {
    const resp = await API.get(ENDPOINTS.FETCH_SLIDER_DATA, true, {
      Authorization: "abcd",
    });
    if (resp.status === 200) {
      setImages(
        resp.data.images.sort(
          (image1, image2) => Number(image1.order) - Number(image2.order)
        )
      );
    }
  };

  return (
    <Carousel
      controls={false}
      interval={3000}
      style={{ width: 420 }}
      className="d-none d-md-block"
    >
      {images.map((item) => (
        <Carousel.Item key={item.id}>
          <img
            className="d-block"
            src={item.imageUrl}
            alt={item.title}
            style={{ height: 660, objectFit: "cover" }}
          />
          <Carousel.Caption>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </Carousel.Caption>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default ImageCarousel;
